import { render, staticRenderFns } from "./divider-primary.vue?vue&type=template&id=ae12e8a4&scoped=true&"
import script from "./divider-primary.vue?vue&type=script&lang=js&"
export * from "./divider-primary.vue?vue&type=script&lang=js&"
import style0 from "./divider-primary.vue?vue&type=style&index=0&id=ae12e8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae12e8a4",
  null
  
)

export default component.exports